import API from "@/services/api";
import { 
  FetchCUPSAvailabiltyData,
  FetchCUPSAvailabiltyParams,
  FetchCUPSAvailabiltyResponse,
  FetchGasCUPSAvailabiltyData,
  FetchGasCUPSAvailabiltyResponse
} from "../types/cups";

enum Endpoints {
  CUPSConfig = "/contractacio/config/cups/:cups",
  GasCUPSConfig = "/gas/contractacio/config/cups/:cups"
}

const validateElectricityCUPSAvailability = (
  cups: FetchCUPSAvailabiltyParams['cups']
) => {
  return new Promise<FetchCUPSAvailabiltyData>(async (resolve, reject) => {
    API.get<FetchCUPSAvailabiltyResponse>({
      endpoint: Endpoints.CUPSConfig,
      params: {
        cups
      },
      versions: [1]
    })
    .then(({promise: { data }}) => {
      resolve({
        sipsDataAvailable: data.cups_data_availability?.available ?? false,
        accessTariff: data.access_tariff.id === "" ? null : data.access_tariff.id,
        accessTariffName: data.access_tariff.name === "" ? null : data.access_tariff.name,
        address: {
          zipcode: data.address.zipcode === "" ? null : data.address.zipcode,
        },
        cupsAvailable: data.cups_availability.available,
        power: !(typeof data.power_p1 === "number") ? null : data.power_p1,
        power2: !(typeof data.power_p2 === "number") ? null : data.power_p2,
        power3: data.power_p3,
        power4: data.power_p4,
        power5: data.power_p5,
        power6: data.power_p6,
        selfcons: (data.selfcons === "" || data.selfcons === undefined) ? false : data.selfcons,
        selfconsCode: (data.autoconsumo_code === "" || data.autoconsumo_code === undefined) ? '00' : data.autoconsumo_code,
        // selfconsCode: null
      })
    })
    .catch(err => {
      reject(err);
    })
  })
}

const validateGasCUPSAvailability = (
  cups: FetchCUPSAvailabiltyParams['cups']
) => {
  return new Promise<FetchGasCUPSAvailabiltyData>(async (resolve, reject) => {
    API.get<FetchGasCUPSAvailabiltyResponse>({
      endpoint: Endpoints.GasCUPSConfig,
      params: {
        cups
      },
      versions: [2]
    })
    .then(({promise: { data }}) => {
      resolve({
        sipsDataAvailable: !!data?.access_tariff?.id,
        accessTariff: !!data?.access_tariff?.id ? data.access_tariff.id : null,
        accessTariffName: !!data?.access_tariff?.id ? data.access_tariff.name : null,
        address: {
          zipcode: !!data?.address?.zipcode ? data.address.zipcode : null,
        },
        cupsAvailable: !!data.cups_availability.available ? data.cups_availability.available : true
      })
    })
    .catch(err => {
      reject(err);
    })
  })
}

export default {
  validateElectricityCUPSAvailability,
  validateGasCUPSAvailability
};


